import { render, staticRenderFns } from "./KeyValueList.vue?vue&type=template&id=1118afb3"
import script from "./KeyValueList.vue?vue&type=script&lang=js"
export * from "./KeyValueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports